import { create } from "zustand";

export const useSocketStatusStore = create((set) => ({
  isConnected: false,
  isConnecting: false,
  
  setConnected: (connected) => set({ isConnected: connected, isConnecting: false }),
  setConnecting: (connecting) => set({ isConnecting: connecting }),
}));

